import React, { Component } from 'react';
import { PropTypes, oneOf } from 'prop-types';
import axios from 'axios';
import classNames from 'classnames';
import SimpleCache from '@thd-olt-global/simple-cache';
import { Heading } from '@thd-olt-component-react/heading';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Rating } from '@thd-olt-component-react/rating';
import { Image } from '@thd-olt-component-react/image';
import { CollectionReviewModel } from '../models/CollectionReviewModel';
import * as envHelper from '../../ratings-env-helper.js';
import './CollectionReviews.styles.scss';

// TODO: Is this being used????
class CollectionReviews extends Component {
  static cache = new SimpleCache('collection-reviews', 3 * 60 * 1000);

  state = {
    collectionModel: '',
    activeKey: 0
  };

  async componentDidMount() {
    const { collectionId } = this.props;
    this.updateCollectionItem({ collectionId });
  }

  async componentDidUpdate(previousProps) {
    const { collectionId } = this.props;
    if (previousProps.collectionId !== collectionId) {
      this.updateCollectionItem({ collectionId });
    }
  }

  getURL = ({ collectionId }) => {
    const { env, apiKey, storeId } = this.props;
    return `${envHelper.getHost(env)}/collection-svcs/collectiondetail/${collectionId}?storeId=${storeId}&key=${apiKey}`;
  };

  setReviewItem = (event, index, sku) => {
    const { onItemClick } = this.props;
    event.preventDefault();
    this.setState({ activeKey: index });
    if (onItemClick) {
      onItemClick(sku);
    }
  };

  async updateCollectionItem({ collectionId }) {
    const { itemId, parentId } = this.props;
    try {
      const response = await this.fetchReviewsForCollection({ collectionId });
      response.data.skus.forEach(function (item, index) {
        if (item.itemId === itemId || item.productId === parentId) {
          const removedItem = response.data.skus.splice(index, 1);
          response.data.skus.unshift(removedItem[0]);
        }
      });

      const collectionModel = new CollectionReviewModel(response.data);
      this.setState({ collectionModel });
    } catch (error) {
      console.log('Error:' + JSON.stringify(error));
    }
  }

  fetchReviewsForCollection = ({ collectionId }) => {
    const url = this.getURL({ collectionId });
    const cached = CollectionReviews.cache.get(url);
    if (cached) {
      return Promise.resolve(cached);
    }
    const promise = axios.get(url);
    CollectionReviews.cache.add(url, promise);
    return promise;
  };

  renderCollectionInfo = (collectionModel = {}) => {
    const isMobile = this.props.channel.toLowerCase() === 'mobile';
    const data = collectionModel.collectionMetadata;
    return (
      <div className="collection-info">
        {
          data
            ? (
              <>
                <Heading title="Customer Reviews" underline />
                <Row className="collection">
                  <Col className="collection__image" fallback="3" xs="1">
                    <Image alt="collectionImage" id={data.imageId} size={isMobile ? '65' : '100'} stretchy={false} />
                  </Col>
                  <Col fallback="9" xs="6" className="description">
                    {
                      isMobile
                        ? (
                          <div>
                            <span className="description__brand">{data.brandName}</span><br />
                            <span className="description__name--mobile">{data.name}</span><br />
                            <span className="description__message--mobile">Select an item to see reviews for that item in the collection</span><br />
                          </div>
                        )
                        : (
                          <div>
                            <span className="description__brand">{data.brandName}</span><br />
                            <span className="description__name">{data.name}</span><br /><br /><br className="description__break--hide" />
                            <span className="description__message">Select an item to see reviews for that item in the collection</span><br />
                          </div>
                        )
                    }
                  </Col>
                </Row>
              </>
            )
            : null
        }
      </div>
    );
  };

  renderCollectionItems = (collectionModel = {}) => {
    const { activeKey } = this.state;
    const { channel } = this.props;
    const isMobile = channel === 'mobile';

    return (collectionModel.collectionItems || []).map((sku, i) => {
      const selectedSlide = classNames({
        'collection-review__selected': activeKey === i,
        'collection-review collection-review__not--selected': activeKey !== i
      });
      const selectedCaret = classNames({
        'collection-review__caret collection-review__caret__selected collection-review__caret--bottom': activeKey === i,
        'collection-review__caret collection-review__caret--bottom': activeKey !== i
      });

      return (
        <div className="collection-review" key={i.toString()}>
          <button onClick={(event) => this.setReviewItem(event, i, sku)}>
            <Row className={selectedSlide}>
              {!isMobile
                ? (
                  <Col xs="4" className="product item--image">
                    <div
                      className="product__image"
                      style={{ backgroundImage: `url(${sku.info.imageUrl.replace(/<SIZE>/gi, '100')})` }}
                    />
                  </Col>
                )
                : null}
              <Col xs={!isMobile ? '8' : '12'} className="product">
                <div className="product__details">
                  <p className="product__details product__details__name">
                    {sku.info.productLabel}
                  </p>
                  <div className="product__rating">
                    <span>
                      <Rating value={Number(sku.ratingsReviews.averageRating)} />
                    </span>
                    <span className="product__review--count">({sku.ratingsReviews.totalReviews})</span>
                  </div>
                </div>
              </Col>
            </Row>
            <div className={selectedCaret}>
              <div className="collection-review__caret--over" />
            </div>
          </button>
        </div>
      );
    });
  };

  render() {
    const { collectionModel, activeKey } = this.state;
    return (
      <div className="collection-reviews" id="collection-reviews">
        {
          collectionModel.numberOfProducts > 0
            ? (
              <>
                {this.renderCollectionInfo(collectionModel)}
                <div className="collection-carousel">
                  <Carousel multiItem showDots={false} selectedItem={activeKey}>
                    {
                      this.renderCollectionItems(collectionModel)
                    }
                  </Carousel>
                </div>
              </>
            )
            : <Heading title="Customer Reviews" underline />
        }
      </div>
    );
  }
}

CollectionReviews.displayName = 'CollectionReviews';

CollectionReviews.propTypes = {
  channel: PropTypes.string,
  env: oneOf(['dev', 'stage', 'prod', 'prod-beta']),
  apiKey: PropTypes.string.isRequired,
  collectionId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  storeId: PropTypes.string,
  onItemClick: PropTypes.func.isRequired
};

CollectionReviews.defaultProps = {
  env: 'prod',
  channel: 'desktop',
  storeId: '121'
};

export default CollectionReviews;
